import { render, staticRenderFns } from "./taskFollow.vue?vue&type=template&id=5f6562cc&scoped=true&"
import script from "./taskFollow.vue?vue&type=script&lang=js&"
export * from "./taskFollow.vue?vue&type=script&lang=js&"
import style0 from "./taskFollow.vue?vue&type=style&index=0&id=5f6562cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6562cc",
  null
  
)

export default component.exports